module.exports = __webpack_public_path__ + "img/arrow-down.7ec00930.svg";